import { cardsForAddress, isAddressQuery } from './vaults.mjs';
import { filterMarket } from './market.mjs';
import { sortCards } from './prices.mjs';
import { traitSource } from './trait-sources.mjs';
export const TRAITS = [
  { key: 'naka', label: 'Head / hair', all: 'All heads / hair' },
  { key: 'background', label: 'Background', all: 'All backgrounds' },
  { key: 'eyes', label: 'Eyes', all: 'All eyes' },
  { key: 'mouth', label: 'Mouth', all: 'All mouths' },
];
// Keep the original metadata and portrait assignments intact. These are display
// aliases, also accepted in saved filter URLs and text searches.
const aliases = { 'VOLCANO CURRENCY': 'SALVADOR VOLCANO', REDPUTIN: 'REDPUTINPEPE' };
export const normalizeTrait = value => {
  const name = String(value || '').trim().toUpperCase();
  return aliases[name] || name;
};
export const selectedTraits = value => [...new Set((Array.isArray(value) ? value : value ? [value] : []).map(normalizeTrait).filter(Boolean))];
const assetNames = new Set(['RAREPEPE', 'PEPEKEEPER', 'FSBPUTINPEPE', 'DANKPEPE', 'FROGBUS', 'JIHANWU', 'BLAINEPEPE', 'PEPECASH', 'LORDKEK', 'HOODEDPEPE', 'HAIRPEPE', 'PEPEMINING', 'PEAKYPEPE', 'PEPESMALLS', 'RADIOPEPE', 'MODERNPEPE', 'PEPEBASQUIAT', 'PEPENOPOULOS', 'RARELORDKEK', 'MELANCHOLIA', 'PEPEMONDRIAN', 'PEPLACERESLT', 'DJPEPE', 'HOMERPEPE', 'PEPEPARTY', 'REDPUTINPEPE']);
export const traitLabel = (value, category) => {
  if (category === 'mouth') {
    const label = { CLASSIC: 'Classic', PEPETOWN: 'PEPETOWN · Cigarette', PEPEJOINTSPH: 'PEPEJOINTSPH · Joint', PEPEOMUERTE: 'PEPEOMUERTE · Cigar' }[normalizeTrait(value)];
    if (label) return label;
  }
  const source = traitSource(category, value);
  if (source && !source.kind) return source.asset;
  const name = normalizeTrait(value);
  return assetNames.has(name) ? name : name.toLowerCase().replace(/\b[a-z]/g, c => c.toUpperCase()).replace(/\b3d\b/i, '3D').replace(/\bNft\b/i, 'NFT');
};

export function filterCards(infos, filters, vaults = {}, skipTrait = '', market = {}) {
  const addressMatches = isAddressQuery(filters.q) ? cardsForAddress(filters.q, market.locations, vaults) : null;
  const query = String(filters.q || '').trim().toLowerCase();
  const ids = Object.keys(infos).map(key => Number(key.slice(1))).filter(id => {
    const info = infos[`#${id}`];
    if (!Number.isInteger(id) || id < 1 || id > 300) return false;
    if (!filterMarket(id, filters.market, market.locations || {}, market.listings || {})) return false;
    if (filters.vault === 'yes' && !vaults[id]?.length) return false;
    if (TRAITS.some(({ key }) => key !== skipTrait && selectedTraits(filters[key]).length && !selectedTraits(filters[key]).includes(normalizeTrait(info[key])))) return false;
    if (!query) return true;
    if (addressMatches) return addressMatches.includes(id);
    if (/^#?\d+$/.test(query)) return id === Number(query.replace('#', ''));
    return TRAITS.some(({ key }) => String(info[key] || '').toLowerCase().includes(query) || traitLabel(info[key], key).toLowerCase().includes(query));
  });
  return sortCards(ids, filters.sort, market.listings, market.rates, market.now);
}

export function traitOptions(infos, filters, vaults, trait, market = {}) {
  const ids = filterCards(infos, filters, vaults, trait, market);
  const counts = new Map();
  for (const id of ids) {
    const value = normalizeTrait(infos[`#${id}`][trait]);
    if (value) counts.set(value, (counts.get(value) || 0) + 1);
  }
  // Retain zero-count options so a selected value never disappears from its select.
  return [...new Set(Object.values(infos).map(info => normalizeTrait(info[trait])).filter(Boolean))]
    .sort().map(value => ({ value, count: counts.get(value) || 0 }));
}
